import React from 'react';

/** Properties interface of the Modal component. */
export interface ModalProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  title: string;
  launcherText?: string;
  launcherTag?: string;
  width?: string;
  openOnLaunch?: boolean;
  showFooter?: boolean;
  closeOnClick?: boolean;
  closeOnEsc?: boolean;
  opened?: boolean;
  isMobile?: boolean;
  closeButtonLabel?: string;
  okButtonLabel?: string;
  onOpenCallback?: () => void;
  onCloseCallback?: () => void;
  onOKCallback?: () => void;
  children: React.ReactNode;
  tabIndex?: number | undefined;
  openWithReturn?: boolean;
  openWithSpacebar?: boolean;
}
